// import { post } from "@insite/client-framework/Services/ApiService";
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const getReportTypesUrl = "api/v2/powerbireport/ReportNames";
const reportDetailsUrl = "/api/v2/powerbireport/ReportDetails";

export interface ReportDetailsResult {
    embedInfo: EmbedInfo;
    token: string;
    filters: any[];
}

export interface EmbedInfo {
    "@odata.context": string;
    id: string;
    reportType: string;
    name: string;
    webUrl: string;
    embedUrl: string;
    isFromPbix: boolean;
    isOwnedByMe: boolean;
    datasetId: string;
    datasetWorkspaceId: string;
    users: any[];
    subscriptions: any[];
    reportFlags: number;
}

export interface loadReportDetailsParam extends ApiParameter {
    reportName: string;
    onError?: (message: string) => void;
    onSuccess?: (result: ReportDetailsResult) => void;
}

export const getReportNames = async () => {
    const response = await get<string[]>(getReportTypesUrl);
    return response;
};
export const getReportDetail = async (parameter: loadReportDetailsParam) => {
    const response = await get<ReportDetailsResult>(`${reportDetailsUrl}?reportName=${parameter.reportName}`);
    return response;
};
